import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnreadMessageService {
  private readonly unreadCountSubject = new BehaviorSubject<number>(0);

  readonly unreadCount$ = this.unreadCountSubject.asObservable();

  /**
   * 읽지 않은 메시지 수를 설정합니다.
   * @param count 읽지 않은 메시지 수
   */
  setUnreadCount(count: number): void {
    this.unreadCountSubject.next(count);
  }

  /**
   * 읽지 않은 메시지 수를 초기화합니다.
   */
  resetUnreadCount(): void {
    this.unreadCountSubject.next(0);
  }

  /**
   * 읽지 않은 메시지 수를 증가시킵니다.
   */
  incrementUnreadCount(): void {
    const currentCount = this.unreadCountSubject.value;
    this.unreadCountSubject.next(currentCount + 1);
  }

  /**
   * 읽지 않은 메시지 수를 감소시킵니다.
   */
  decrementUnreadCount(): void {
    const currentCount = this.unreadCountSubject.value;
    if (currentCount > 0) {
      this.unreadCountSubject.next(currentCount - 1);
    }
  }
}
